module.exports = __webpack_public_path__ + "static/media/BackGroundImage.73f518fb.png";